<template>
	<transition name="playlist_edit">
		<div class="playlist_edit">
			<button @click="backPage">back</button>
			<button @click="saveChannelsInPlaylist"
			        v-if="getUserRights">save
			</button>
			<transition name="saved-ani">
				<p class="saved" v-if="saved">Данные сохранены</p>
			</transition>
			<transition name="saved-ani">
				<p class="error" v-if="errorSave">Ошибка при добавлении</p>
			</transition>
			<div class="wrap">
				<p>редактирование содержимого плейлиста
					<span class="bold" id="bold">{{ getPlaylists[getCountPlaylists].name }}</span>
				</p>
				<p v-if="emptyValue" class="red">есть пустые значение в номерах кнопок</p>
				<p v-if="repeatValue" class="red">какие-то номера кнопок совпадают</p>
			</div>
			<div class="container">
				<div class="cont">
					<span class="span1">
						<label for="span1">
							<input type="text"
							       placeholder="поиск"
							       @keyup="sortChannel"
							       id="span1"/>
							<button @click="clear" value="1">clear</button>
						</label>
						<span>доступные каналы</span>
						<span class="all-ch"
						      @click="addAllChannels"
						      v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"
						      title="добавить все каналы в плейлист">=></span>
					</span>
					<div class="all_channels" @mouseout="scroll">
						<div v-for="(elem, i) in listCh"
						     :value="elem.name"
						     :aria="elem.display_name + (elem.is_ottfree ? ' OTT free' : '')"
						     :key="i"
						     class="playlist_edit-item">
							<span>{{ elem.display_name }}</span>
							<span class="add"
							      @click="addChannelInPlaylist"
							      v-if="getUserRights"></span>
							<span class="free">{{elem.is_ottfree ? "OTT free" :
							""}}</span>
						</div>
					</div>
				</div>
				<div class="cont">
					<span class="span2">
						<label for="span2">
							<input type="text"
							       placeholder="поиск"
							       @keyup="sortChannel"
							       id="span2"/>
							<button @click="clear" value="2">clear</button>
						</label>
						<span>каналы в плейлисте</span>
						<span class="all-ch"
						      @click="deleteAllChannels"
						      v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"
						      title="удалить все каналы из плейлиста"><=</span>
					</span>
					<transition-group tag="div"
					                  name="playlist"
					                  class="playlist_channels"
					                  v-scroll="scroll">
						<div v-for="(elem, i) in listPl"
						     :value="elem.name"
						     :aria="elem.display_name + (elem.is_ottfree ? ' OTT free' : '')"
						     :key="i"
						     class="playlist_edit-item">
							<span>{{ elem.button }}</span>
							<span>. </span>
							<span>{{ elem.display_name }}</span>
							<span class="free">{{elem.is_ottfree ? "OTT free" : ""}}</span>
							<p class="edit_button">
								<label for="edit"
								       v-if="num"
								       :key="'num'">
									<span class="bold red">
										значениями могут быть только цифры</span>
								</label>
								<label for="edit"
								       v-else-if="error"
								       :key="'err'">
									<span class="bold red">такая кнопка уже есть</span>
								</label>
								<label for="edit"
								       v-else
								       :key="'ok'">
									<span class="bold">номер кнопки {{ elem.name }}</span>
								</label>
								<input type="text"
								       id="edit"
								       value=""
								       @focus="error = false; num = false"/>
								<span class="btn"
								      v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'">
									<button @click="saveButton">ok</button>
									<button @click="exchangeChannels">exchange</button>
									<button @click="cancel">cancel</button>
								</span>
							</p>
							<span class="edit"
							      @click="edit"
							      v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"></span>
							<span class="del"
							      @click="del"
							      v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"></span>
						</div>
					</transition-group>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
	import { mapGetters, mapActions } from "vuex";
	import _                          from "lodash";
	import { performRequest }         from "../script/ws/wsclient";

	export default {
		name:     "PlaylistEdit",
		data() {
			return {
				listCh:      [],
				listPl:      [],
				error:       false,
				num:         false,
				editing:     false,
				emptyValue:  false,
				repeatValue: false,
				saved:       false,
				errorSave:   false
			};
		},
		mounted() {
			this.listPl = [].slice.call(this.getPlaylist);
			this.sort();
		},
		methods:  {
			...mapActions(["setChannelist", "setPlaylist"]),
			addAllChannels() {
				Array
					.from(document.querySelector(".all_channels").children)
					.forEach((e) => {
						this.addCh(e);
					});
			},
			addChannelInPlaylist(e) {
				this.addCh(e.target.parentNode);
			},
			addCh(element) {
				this.error     = false;
				let numChannel = 1;
				for (let num of this.listPl) {
					if (num.button && num.button >= numChannel) {
						numChannel = num.button + 1;
					}
				}
				this.listPl.push({
					name:         element.getAttribute("value"),
					display_name: element.firstChild.innerText,
					is_ottfree:   element.lastChild.innerText === "OTT free" ? 1 : 0,
					button:       numChannel
				});
				this.sort();
				this.listPl = _.sortBy(this.listPl, [
					obj => {
						return obj.button;
					},
				]);
			},
			deleteAllChannels() {
				Array
					.from(document.querySelector(".playlist_channels").children)
					.forEach((e) => {
						this.delCh(e);
					});
			},
			del(e) {
				this.delCh(e.target.parentNode);
			},
			delCh(ch) {
				this.error = false;
				for (let item in this.listPl) {
					if (
						this.listPl[item].name ===
						ch.getAttribute("value")
					) {
						this.listPl.splice(item, 1);
					}
				}
				this.sort();
			},
			sortChannel(e) {
				let elemArr  = [];
				let inputMes = "";
				if (e.target.tagName === "INPUT") {
					elemArr  = e
						.target
						.parentNode
						.parentNode
						.nextElementSibling
						.children;
					inputMes = e.target.value;
				} else if (e.target.tagName === "SPAN") {
					elemArr  = e
						.target
						.parentNode
						.parentNode
						.children;
					inputMes = e
						.target
						.parentNode
						.parentNode
						.parentNode
						.firstChild
						.firstChild
						.firstChild
						.value;
				}
				this.handlerShowElements(elemArr, inputMes);
			},
			clear(e) {
				e.target.parentNode.firstChild.value = "";
				e.target.parentNode.firstChild.focus();
				if (e.target.value === "1") {
					let elemArr  = document.querySelector(".all_channels").children;
					let inputMes = document.querySelector("#span1").value;
					this.handlerShowElements(elemArr, inputMes);
				} else if (e.target.value === "2") {
					let elemArr  = document.querySelector(".playlist_channels").children;
					let inputMes = document.querySelector("#span2").value;
					this.handlerShowElements(elemArr, inputMes);
				}
			},
			handlerShowElements(elemArr, inputMes) {
				Array.from(elemArr).forEach(elem => {
					if (inputMes === "") {
						this.showElements(elem);
					} else {
						if (elem
							.getAttribute("aria")
							.toUpperCase()
							.indexOf(inputMes.toUpperCase()) === -1) {
							elem.style.visibility = "hidden";
							elem.style.height     = "0";
							elem.style.padding    = "0";
							elem.style.margin     = "0";
						} else {
							this.showElements(elem);
						}
					}
				});
			},
			showElements(elem) {
				elem.style.visibility = "visible";
				elem.style.height     = "2rem";
				elem.style.padding    = "0.2rem 0.5rem";
				elem.style.margin     = "0 0.2rem";
			},
			scroll() {
				let arr = Array.from(
					document.querySelectorAll(".playlist_channels div")
				);
				for (let item of arr) {
					for (let elem of item.children) {
						if (elem.classList.contains("none")) {
							elem.classList.remove("none");
							this.editing = false;
						}
					}
				}
			},
			backPage() {
				this.$router.go(-1);
			},
			exchangeChannels(e) {
				let channel     = e
					.target
					.parentNode
					.parentNode
					.parentNode
					.getAttribute("value");
				let thisChannel = +e
					.target
					.parentNode
					.parentNode
					.parentNode
					.firstChild.innerText;
				let str         = e.target
					.parentNode
					.previousElementSibling
					.value;
				for (let i = 0; i < str.length; i++) {
					if (_.isNaN(+str[i])) {
						return ( this.num = true );
					}
				}
				if (!this.num) {
					for (let obj in this.listPl) {
						if (
							thisChannel !== 0 &&
							this.listPl[obj].button &&
							this.listPl[obj].button === +str
						) {
							this.listPl[obj].button = +thisChannel;
							for (let obj1 in this.listPl) {
								if (this.listPl[obj1].name === channel) {
									this.listPl[obj1].button = +e.target.parentNode
										.previousElementSibling.value;
								}
							}
							this.listPl = _.sortBy(this.listPl, [
								obj => {
									return obj.button;
								},
							]);
							e.target.parentNode.parentNode.classList.toggle("none");
							this.editing = false;
						}
					}
				}
			},
			saveChannelsInPlaylist() {
				for (let elem in this.listPl) {
					if (this.listPl[elem].button === "") {
						return this.emptyValue = true;
					} else {
						this.emptyValue = false;
						for (let elem2 in this.listPl) {
							if (this.listPl[elem] !== this.listPl[elem2] &&
								this.listPl[elem].button === this.listPl[elem2].button) {
								return this.repeatValue = true;
							} else {
								this.repeatValue = false;
							}
						}
					}
				}
				if (!this.repeatValue && !this.emptyValue) {
					performRequest(
						{
							section: "tvcontent.playlist",

							name: "savePlaylistChannelList"
						},
						{
							name:        this.getPlaylists[this.getCountPlaylists].name,
							channelList: this.listPl,
							operator:    this.getViewUser
						},
						a => {
							if (a.code === 200) {
								this.saved = true;
								setTimeout(() => {
									this.saved = false;
								}, 5000);
							} else {
								this.error     = true;
								this.errorSave = true;
								setTimeout(() => {
									this.errorSave = false;
								}, 7000);
								console.log("error");
							}
						}
					);
				}
			},
			edit(e) {
				let arr      = Array.from(
					document.querySelectorAll(".playlist_channels div")
				);
				this.error   = false;
				this.editing = true;
				this.num     = false;

				for (let item of arr) {
					if (item === e.target.parentNode) {
						for (let elem of item.children) {
							if (elem.classList.contains("edit_button")) {
								elem.classList.toggle("none");
							}
						}
					} else {
						for (let elem of item.children) {
							if (elem.classList.contains("none")) {
								elem.classList.remove("none");
							}
						}
					}
				}

				document
					.querySelector(
						`div[value="${e
							.target
							.parentNode
							.getAttribute("value")}"] .edit_button input`
					)
					.focus();
			},
			cancel(e) {
				e.target.parentNode.parentNode.classList.toggle("none");
			},
			saveButton(e) {
				let channel = e
					.target
					.parentNode
					.parentNode
					.parentNode
					.getAttribute("value");
				let button  = e
					.target
					.parentNode
					.previousElementSibling
					.value;
				let str     = button.toString();

				if (e.target.parentNode.previousElementSibling.value !== "") {
					for (let i = 0; i < str.length; i++) {
						if (_.isNaN(+str[i])) {
							return ( this.num = true );
						}
					}

					for (let btn = 0; btn < this.listPl.length; btn++) {
						if (this.listPl[btn].button === +button) {
							return ( this.error = true );
						}
					}
					if (!this.error) {
						for (let elem of this.listPl) {
							if (elem.name === channel) {
								elem.button = +e
									.target
									.parentNode
									.previousElementSibling
									.value
									.trim();
								e.target
									.parentNode
									.parentNode
									.classList
									.toggle("none");
								this.editing = false;
							}
						}
					}
				}
				this.listPl = _.sortBy(this.listPl, [
					obj => {
						return obj.button;
					},
				]);
			},
			sort() {
				this.listCh = [].slice.call(this.getChannelList);
				for (let item2 of this.listPl) {
					for (let item in this.listCh) {
						if (item2.name === this.listCh[item].name &&
							item2.is_ottfree === this.listCh[item].is_ottfree) {
							this.listCh.splice(item, 1);
						}
					}
				}
			},
		},
		computed: {
			...mapGetters([
				"getChannelList",
				"getPlaylist",
				"getPlaylists",
				"getCountPlaylists",
				"getUserRights",
				"getReqUserRole",
				"getViewUser"
			]),
		},
		watch:    {
			listCh() {
				this.$nextTick(() => {
					let elemArr  = document.querySelector(".all_channels").children;
					let inputMes = document.querySelector("#span1").value;
					this.handlerShowElements(elemArr, inputMes);
				});
			},
			listPl() {
				this.$nextTick(() => {
					let elemArr  = document.querySelector(".playlist_channels").children;
					let inputMes = document.querySelector("#span2").value;
					this.handlerShowElements(elemArr, inputMes);
				});
			}
		},
	};
</script>
<style scoped lang="scss">
	.playlist_edit {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		padding: 0.5rem 0.5rem 1rem 0.5rem;
		height: calc(100vh - 5rem);
		overflow: auto;
		position: absolute;
		margin-top: 4rem;
		width: 90%;
		min-width: 500px;
		right: 50%;
		transform: translateX(50%);
		flex-direction: column;
		.saved, .error {
			position: absolute;
			color: #36741f;
			font-weight: bold;
			padding: 5px 10px 10px 10px;
			top: 14px;
			left: 200px;
			height: 2.5rem;
			background-color: rgba(134, 215, 131, 0.79);
			border-radius: 5px;
			line-height: 1.8rem;
		}
		.error {
			color: #81201b;
			background-color: rgba(215, 116, 136, 0.79);
		}
		button {
			background: #bbf291;
			border-radius: 0.2rem;
			line-height: 1.8rem;
			border: none;
			outline: none;
			height: 2.5rem;
			padding: 0.2rem 1rem;
			transition: all 0.2s;
			cursor: pointer;
			margin: 0.5rem;
			&:hover {
				background: #78956b;
				color: white;
				&:active {
					box-shadow: 0 0 1rem #967068;
				}
			}
		}
		
		.wrap {
			margin: 0.1rem 0.5rem;
			float: right;
			p {
				margin: 0;
			}
			.bold {
				font-weight: bold;
			}
			.red {
				color: rgba(221, 42, 20, 0.92);
			}
		}
		.wrap2 {
			float: left;
		}
		.container {
			display: flex;
			flex-direction: row;
			margin: 0 0.5rem;
			.cont {
				flex-grow: 1;
				.span1,
				.span2 {
					display: flex;
					justify-content: space-between;
					width: 100%;
					background-color: rgb(118, 118, 118);
					font-size: 1.1rem;
					color: #fff;
					text-align: center;
					z-index: 10;
					user-select: none;
					.all-ch {
						min-width: 2rem;
						background-color: #fff;
						color: #000;
						cursor: pointer;
						display: flex;
						align-items: center;
					}
					span {
						padding: 1px 5px;
					}
					label {
						margin: 0;
						position: relative;
						button {
							position: absolute;
							top: -7px;
							right: -7px;
							height: 100%;
							background-color: rgba(255, 255, 255, 0.44);
							border-radius: 0;
							line-height: 0;
							padding: 0 .5rem;
							font-size: .9rem;
							&:hover {
								color: #443e46;
								background-color: rgba(172, 172, 172, 0.86);
							}
						}
						input {
							outline: none;
							border: none;
							padding-left: 5px;
							min-height: 100%;
							width: 250px;
							background-color: rgba(255, 255, 255, 0.24);
							transition: all .3s;
							&::placeholder {
								color: rgba(255, 255, 255, 0.8);
							}
							&:focus {
								background-color: rgba(255, 255, 255, 0.44);
								&::placeholder {
									color: rgba(101, 101, 101, 0.8);
								}
							}
						}
					}
					
				}
				.span2 {
					width: calc(100% - 0.5rem);
					margin-left: 0.5rem;
				}
			}
			.playlist_channels,
			.all_channels {
				background-color: rgba(150, 214, 149, 0.9);
				height: calc(100vh - 12rem);
				overflow: auto;
				overflow-x: hidden;
				display: flex;
				flex-direction: column;
				padding: 0.2rem 0 0.6rem 0;
				
				.playlist_edit-item {
					padding: 0.2rem 0.5rem;
					margin: 0 0.2rem;
					height: 2rem;
					cursor: pointer;
					position: relative;
					user-select: none;
					transition: all 0.3s;
					span.free {
						font-size: .7rem;
						color: #156e23;
						font-weight: bold;
					}
					&::before {
						content: "";
						display: block;
						position: absolute;
						height: 2px;
						width: 100%;
						bottom: 0;
						left: 0;
						background-color: white;
					}
					&::after {
						content: "";
						display: block;
						position: absolute;
						height: 2px;
						width: 0;
						bottom: 0;
						right: 0;
						background-color: #555;
						transition: width 0.3s;
					}
					.add,
					.del,
					.edit {
						position: absolute;
						display: block;
						width: 0;
						height: 0;
						right: 0;
						margin-top: -1.8rem;
						z-index: 5;
						transition: all .3s;
					}
					.add {
						background: url("../../static/plus.png") no-repeat center;
						background-size: 75%;
					}
					.del {
						background: url("../../static/minus.png") no-repeat center;
						background-size: 75%;
					}
					.edit {
						background: url("../../static/edit.png") no-repeat center;
						background-size: 60%;
						right: 2rem;
					}
					&:hover {
						background-color: #fff;
						box-shadow: 0 0 5px #69bf8f;
						&::after {
							width: 100%;
						}
					}
					&:hover .add,
					&:hover .del,
					&:hover .edit {
						width: 2rem;
						height: 2rem;
					}
				}
			}
			.playlist_channels {
				background-color: rgb(163, 194, 212);
				margin-left: 0.5rem;
				padding-bottom: 10rem;
				.bold {
					font-weight: bold;
				}
				.red {
					color: rgba(221, 42, 20, 0.92);
				}
				.edit_button {
					position: absolute;
					background-color: #dfdfdf;
					display: none;
					flex-direction: column;
					width: 100%;
					right: 0;
					margin-top: -1.8rem;
					z-index: 1000;
					padding: 0.5rem;
					box-shadow: 0 0 5px #777;
					.btn {
						display: flex;
						justify-content: space-between;
						button {
							margin: 0;
							flex-grow: 1;
							&:last-child {
								margin-left: 0.5rem;
							}
							&:first-child {
								margin-right: 0.5rem;
							}
						}
					}
					input[type="text"] {
						border-radius: 3px;
						outline: none;
						border: 1px solid #c9c9c9;
						padding-left: 5px;
						flex-grow: 1;
						margin-bottom: 5px;
						&:focus {
							box-shadow: 0 0 5px #69bf8f;
						}
					}
				}
				.none {
					display: flex;
				}
			}
		}
	}
	@media (max-width: 620px) {
		.playlist_edit {
			margin-top: 8rem;
			height: calc(100vh - 9rem);
			.container {
				.playlist_channels,
				.all_channels {
					height: calc(100vh - 16rem);
				}
			}
		}
	}
	.playlist_edit-enter-active {
		transition: opacity 0.5s ease;
	}
	.playlist_edit-leave-active {
		transition: opacity 0.5s ease;
	}
	.playlist_edit-enter,
	.playlist_edit-leave-to {
		opacity: 0;
	}
	.saved-ani-enter-active {
		transition: opacity 0.5s ease;
	}
	.saved-ani-leave-active {
		transition: opacity 0.5s ease;
	}
	.saved-ani-enter,
	.saved-ani-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/PlaylistEdit.vue